<!-- 目标制定 组件 -->
<template>
  <h-inspection-page :title="h_i18n('bc2013c0fcd036406f59c4920b4cf011')+ kindTypeName" class="target_setting_style" @inspection-update="inspectionUpdate" style="background: #F2F4F7;" :isOwnBack="true" @handleBack="handleBack">
    <!-- <inspection-header-new title="生态圈目标签订" title-height="80px" :showNewLogo="true" v-loading="loading" :isHidenRight="true"></inspection-header-new> -->
    <inspection-body>
      <!-- 预留插槽 -->
      <slot name="top"></slot>
    </inspection-body>
    <div class="hwork_targetSigned_inner_table_style">
      <div class="targetSigned_table_title_style">
        <span class="targetSigned_table_left_style" v-if="kindTypeName == '优化'">{{ h_i18n('83162eb93ac2eb9dc8ef5f18dbe50628') }}</span>
        <span class="targetSigned_table_left_style" v-else>{{ h_i18n('b05c32a7d1c19cc8112d3ae9e1aefe82') }}</span>
        <span class="targetSigned_table_right_style">{{ h_i18n('c860dd2df482c75e300282cbde063fb8') }}</span></div>
    <h-table-card>
      <el-table :data="data.tableLossTargetLabel" border style="width: 100%">
        <el-table-column prop="project" :label="h_i18n('31ecc0e65b4cd3e6b12577382bb56d6a')" min-width="130"></el-table-column>
        <el-table-column prop="year" :label="h_i18n('a55a7858f27d0217db05f6de766d0154')" min-width="80">
          <template #default="{row,$index}">
            <span>{{ row.year }}</span>
            <span style="color: #c0c4c0;" v-if="row.year && ($index == 0 || $index == 2) "> %</span>
          </template>
        </el-table-column>
        <el-table-column prop="jan" :label="h_i18n('fccc2b4ac9cd71904395042cd0f3fd92')" min-width="80">
          <template #default="{row,$index}">
            <el-input @change="monthChange(row,'jan',$index)" :disabled="kindType == 'optimize' && optimizeMonth > 1"
            v-if="($index == 0 || $index == 2) && (kindType == 'targetSet' || kindType == 'optimize')" v-model="row.jan">
              <template #suffix>%</template>
            </el-input>
            <span v-else-if="$index == 0 || $index == 2">{{ row.jan }} <span style="color: #c0c4c0;">%</span></span>
            <span v-else>{{ row.jan }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="feb" :label="h_i18n('c1d13f1d962efb0dd59f4f1e9f9570c9')" min-width="80">
          <template #default="{row,$index}">
            <el-input @change="monthChange(row,'feb',$index)" :disabled="kindType == 'optimize' && optimizeMonth > 2"
            v-if="($index == 0 || $index == 2) && (kindType == 'targetSet' || kindType == 'optimize')" v-model="row.feb">
              <template #suffix>%</template>
            </el-input>
            <span v-else-if="$index == 0 || $index == 2">{{ row.feb }} <span style="color: #c0c4c0;">%</span></span>
            <span v-else>{{ row.feb }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="mar" :label="h_i18n('c4767bc3ad5c6812a8ea302e6126d988')" min-width="80">
          <template #default="{row,$index}">
            <el-input @change="monthChange(row,'mar',$index)" :disabled="kindType == 'optimize' && optimizeMonth > 3"
            v-if="($index == 0 || $index == 2) && (kindType == 'targetSet' || kindType == 'optimize')" v-model="row.mar">
              <template #suffix>%</template>
            </el-input>
            <span v-else-if="$index == 0 || $index == 2">{{ row.mar }} <span style="color: #c0c4c0;">%</span></span>
            <span v-else>{{ row.mar }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="apr" :label="h_i18n('3eaf4b307f8f2507e6849f991efe596e')" min-width="80">
          <template #default="{row,$index}">
            <el-input @change="monthChange(row,'apr',$index)" :disabled="kindType == 'optimize' && optimizeMonth > 4"
            v-if="($index == 0 || $index == 2) && (kindType == 'targetSet' || kindType == 'optimize')" v-model="row.apr">
              <template #suffix>%</template>
            </el-input>
            <span v-else-if="$index == 0 || $index == 2">{{ row.apr }} <span style="color: #c0c4c0;">%</span></span>
            <span v-else>{{ row.apr }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="may" :label="h_i18n('0545f138f0f61021efc3d3190d955015')" min-width="80">
          <template #default="{row,$index}">
            <el-input @change="monthChange(row,'may',$index)" :disabled="kindType == 'optimize' && optimizeMonth > 5"
            v-if="($index == 0 || $index == 2) && (kindType == 'targetSet' || kindType == 'optimize')" v-model="row.may">
              <template #suffix>%</template>
            </el-input>
            <span v-else-if="$index == 0 || $index == 2">{{ row.may }} <span style="color: #c0c4c0;">%</span></span>
            <span v-else>{{ row.may }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="jun" :label="h_i18n('f2422a6e4299609a1b1cf3b3fcaf9282')" min-width="80">
          <template #default="{row,$index}">
            <el-input @change="monthChange(row,'jun',$index)" :disabled="kindType == 'optimize' && optimizeMonth > 6"
            v-if="($index == 0 || $index == 2) && (kindType == 'targetSet' || kindType == 'optimize')" v-model="row.jun">
              <template #suffix>%</template>
            </el-input>
            <span v-else-if="$index == 0 || $index == 2">{{ row.jun }} <span style="color: #c0c4c0;">%</span></span>
            <span v-else>{{ row.jun }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="jul" :label="h_i18n('464bab7f82a4361e017a73dd6b958916')" min-width="80">
          <template #default="{row,$index}">
            <el-input @change="monthChange(row,'jul',$index)" :disabled="kindType == 'optimize' && optimizeMonth > 7"
            v-if="($index == 0 || $index == 2) && (kindType == 'targetSet' || kindType == 'optimize')" v-model="row.jul">
              <template #suffix>%</template>
            </el-input>
            <span v-else-if="$index == 0 || $index == 2">{{ row.jul }} <span style="color: #c0c4c0;">%</span></span>
            <span v-else>{{ row.jul }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="aug" :label="h_i18n('81017142849e31d0ca86c31c6f62a00e')" min-width="80">
          <template #default="{row,$index}">
            <el-input @change="monthChange(row,'aug',$index)" :disabled="kindType == 'optimize' && optimizeMonth > 8"
            v-if="($index == 0 || $index == 2) && (kindType == 'targetSet' || kindType == 'optimize')" v-model="row.aug">
              <template #suffix>%</template>
            </el-input>
            <span v-else-if="$index == 0 || $index == 2">{{ row.aug }} <span style="color: #c0c4c0;">%</span></span>
            <span v-else>{{ row.aug }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="sept" :label="h_i18n('4b592d5efd59199a8e6b4ad57ecc84c2')" min-width="80">
          <template #default="{row,$index}">
            <el-input @change="monthChange(row,'sept',$index)" :disabled="kindType == 'optimize' && optimizeMonth > 9"
            v-if="($index == 0 || $index == 2) && (kindType == 'targetSet' || kindType == 'optimize')" v-model="row.sept">
              <template #suffix>%</template>
            </el-input>
            <span v-else-if="$index == 0 || $index == 2">{{ row.sept }} <span style="color: #c0c4c0;">%</span></span>
            <span v-else>{{ row.sept }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="oct" :label="h_i18n('f544c3992587891eaefa4dce866bfebd')" min-width="80">
          <template #default="{row,$index}">
            <el-input @change="monthChange(row,'oct',$index)" :disabled="kindType == 'optimize' && optimizeMonth > 10"
            v-if="($index == 0 || $index == 2) && (kindType == 'targetSet' || kindType == 'optimize')" v-model="row.oct">
              <template #suffix>%</template>
            </el-input>
            <span v-else-if="$index == 0 || $index == 2">{{ row.oct }} <span style="color: #c0c4c0;">%</span></span>
            <span v-else>{{ row.oct }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="nov" :label="h_i18n('57c4475588f6c2c44d526eb338720c3c')" min-width="80">
          <template #default="{row,$index}">
            <el-input @change="monthChange(row,'nov',$index)" :disabled="kindType == 'optimize' && optimizeMonth > 11"
            v-if="($index == 0 || $index == 2) && (kindType == 'targetSet' || kindType == 'optimize')" v-model="row.nov">
              <template #suffix>%</template>
            </el-input>
            <span v-else-if="$index == 0 || $index == 2">{{ row.nov }} <span style="color: #c0c4c0;">%</span></span>
            <span v-else>{{ row.nov }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="dec" :label="h_i18n('c0615eb33be499a472b1b1f1befd1db1')" min-width="80">
          <template #default="{row,$index}">
            <el-input @change="monthChange(row,'dec',$index)" :disabled="kindType == 'optimize' && optimizeMonth > 12"
            v-if="($index == 0 || $index == 2) && (kindType == 'targetSet' || kindType == 'optimize')" v-model="row.dec">
              <template #suffix>%</template>
            </el-input>
            <span v-else-if="$index == 0 || $index == 2">{{ row.dec }} <span style="color: #c0c4c0;">%</span></span>
            <span v-else>{{ row.dec }}</span>
          </template>
        </el-table-column>
      </el-table>
    </h-table-card>
  </div>
    <div class="hwork_targetSigned_inner_table_style">
    <div class="targetSigned_table_title_style">
      <span class="targetSigned_table_left_style" v-if="kindTypeName == '优化'">{{ h_i18n('4a980200488b121339185ff970d20d87') }}</span>
      <span class="targetSigned_table_left_style" v-else>{{ h_i18n('efb509d691a823af0f9796a585d21a33') }}</span>
    </div>
    <h-table-card>
      <el-table :data="data.tableBadQuantityTargetLabel" border style="width: 100%">
        <el-table-column prop="project" :label="h_i18n('31ecc0e65b4cd3e6b12577382bb56d6a')" min-width="120"></el-table-column>
        <el-table-column prop="year" :label="h_i18n('a55a7858f27d0217db05f6de766d0154')" min-width="80">
          <template #default="{row,$index}">
            <span>{{ row.year }}</span>
            <span style="color: #c0c4c0;" v-if="row.year && ($index == 0 || $index == 2) "> %</span>
          </template>
        </el-table-column>
        <el-table-column prop="jan" :label="h_i18n('fccc2b4ac9cd71904395042cd0f3fd92')" min-width="80">
          <template #default="{row,$index}">
            <el-input @change="changeMonth(row,'jan',$index)" :disabled="kindType == 'optimize' && optimizeMonth > 1"
            v-if="($index == 0 || $index == 2) && (kindType == 'targetSet' || kindType == 'optimize')" v-model="row.jan">
              <template #suffix>%</template>
            </el-input>
            <span v-else-if="$index == 0 || $index == 2">{{ row.jan }} <span style="color: #c0c4c0;">%</span></span>
            <span v-else>{{ row.jan }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="feb" :label="h_i18n('c1d13f1d962efb0dd59f4f1e9f9570c9')" min-width="80">
          <template #default="{row,$index}">
            <el-input @change="changeMonth(row,'feb',$index)" :disabled="kindType == 'optimize' && optimizeMonth > 2"
            v-if="($index == 0 || $index == 2) && (kindType == 'targetSet' || kindType == 'optimize')" v-model="row.feb">
              <template #suffix>%</template>
            </el-input>
            <span v-else-if="$index == 0 || $index == 2">{{ row.feb }} <span style="color: #c0c4c0;">%</span></span>
            <span v-else>{{ row.feb }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="mar" :label="h_i18n('c4767bc3ad5c6812a8ea302e6126d988')" min-width="80">
          <template #default="{row,$index}">
            <el-input @change="changeMonth(row,'mar',$index)" :disabled="kindType == 'optimize' && optimizeMonth > 3"
            v-if="($index == 0 || $index == 2) && (kindType == 'targetSet' || kindType == 'optimize')" v-model="row.mar">
              <template #suffix>%</template>
            </el-input>
            <span v-else-if="$index == 0 || $index == 2">{{ row.mar }} <span style="color: #c0c4c0;">%</span></span>
            <span v-else>{{ row.mar }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="apr" :label="h_i18n('3eaf4b307f8f2507e6849f991efe596e')" min-width="80">
          <template #default="{row,$index}">
            <el-input @change="changeMonth(row,'apr',$index)" :disabled="kindType == 'optimize' && optimizeMonth > 4"
            v-if="($index == 0 || $index == 2) && (kindType == 'targetSet' || kindType == 'optimize')" v-model="row.apr">
              <template #suffix>%</template>
            </el-input>
            <span v-else-if="$index == 0 || $index == 2">{{ row.apr }} <span style="color: #c0c4c0;">%</span></span>
            <span v-else>{{ row.apr }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="may" :label="h_i18n('0545f138f0f61021efc3d3190d955015')" min-width="80">
          <template #default="{row,$index}">
            <el-input @change="changeMonth(row,'may',$index)" :disabled="kindType == 'optimize' && optimizeMonth > 5"
            v-if="($index == 0 || $index == 2) && (kindType == 'targetSet' || kindType == 'optimize')" v-model="row.may">
              <template #suffix>%</template>
            </el-input>
            <span v-else-if="$index == 0 || $index == 2">{{ row.may }} <span style="color: #c0c4c0;">%</span></span>
            <span v-else>{{ row.may }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="jun" :label="h_i18n('f2422a6e4299609a1b1cf3b3fcaf9282')" min-width="80">
          <template #default="{row,$index}">
            <el-input @change="changeMonth(row,'jun',$index)" :disabled="kindType == 'optimize' && optimizeMonth > 6"
            v-if="($index == 0 || $index == 2) && (kindType == 'targetSet' || kindType == 'optimize')" v-model="row.jun">
              <template #suffix>%</template>
            </el-input>
            <span v-else-if="$index == 0 || $index == 2">{{ row.jun }} <span style="color: #c0c4c0;">%</span></span>
            <span v-else>{{ row.jun }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="jul" :label="h_i18n('464bab7f82a4361e017a73dd6b958916')" min-width="80">
          <template #default="{row,$index}">
            <el-input @change="changeMonth(row,'jul',$index)" :disabled="kindType == 'optimize' && optimizeMonth > 7"
            v-if="($index == 0 || $index == 2) && (kindType == 'targetSet' || kindType == 'optimize')" v-model="row.jul">
              <template #suffix>%</template>
            </el-input>
            <span v-else-if="$index == 0 || $index == 2">{{ row.jul }} <span style="color: #c0c4c0;">%</span></span>
            <span v-else>{{ row.jul }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="aug" :label="h_i18n('81017142849e31d0ca86c31c6f62a00e')" min-width="80">
          <template #default="{row,$index}">
            <el-input @change="changeMonth(row,'aug',$index)" :disabled="kindType == 'optimize' && optimizeMonth > 8"
            v-if="($index == 0 || $index == 2) && (kindType == 'targetSet' || kindType == 'optimize')" v-model="row.aug">
              <template #suffix>%</template>
            </el-input>
            <span v-else-if="$index == 0 || $index == 2">{{ row.aug }} <span style="color: #c0c4c0;">%</span></span>
            <span v-else>{{ row.aug }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="sept" :label="h_i18n('4b592d5efd59199a8e6b4ad57ecc84c2')" min-width="80">
          <template #default="{row,$index}">
            <el-input @change="changeMonth(row,'sept',$index)" :disabled="kindType == 'optimize' && optimizeMonth > 9"
            v-if="($index == 0 || $index == 2) && (kindType == 'targetSet' || kindType == 'optimize')" v-model="row.sept">
              <template #suffix>%</template>
            </el-input>
            <span v-else-if="$index == 0 || $index == 2">{{ row.sept }} <span style="color: #c0c4c0;">%</span></span>
            <span v-else>{{ row.sept }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="oct" :label="h_i18n('f544c3992587891eaefa4dce866bfebd')" min-width="80">
          <template #default="{row,$index}">
            <el-input @change="changeMonth(row,'oct',$index)" :disabled="kindType == 'optimize' && optimizeMonth > 10"
            v-if="($index == 0 || $index == 2) && (kindType == 'targetSet' || kindType == 'optimize')" v-model="row.oct">
              <template #suffix>%</template>
            </el-input>
            <span v-else-if="$index == 0 || $index == 2">{{ row.oct }} <span style="color: #c0c4c0;">%</span></span>
            <span v-else>{{ row.oct }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="nov" :label="h_i18n('57c4475588f6c2c44d526eb338720c3c')" min-width="80">
          <template #default="{row,$index}">
            <el-input @change="changeMonth(row,'nov',$index)" :disabled="kindType == 'optimize' && optimizeMonth > 11"
            v-if="($index == 0 || $index == 2) && (kindType == 'targetSet' || kindType == 'optimize')" v-model="row.nov">
              <template #suffix>%</template>
            </el-input>
            <span v-else-if="$index == 0 || $index == 2">{{ row.nov }} <span style="color: #c0c4c0;">%</span></span>
            <span v-else>{{ row.nov }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="dec" :label="h_i18n('c0615eb33be499a472b1b1f1befd1db1')" min-width="80">
          <template #default="{row,$index}">
            <el-input @change="changeMonth(row,'dec',$index)" :disabled="kindType == 'optimize' && optimizeMonth > 12"
            v-if="($index == 0 || $index == 2) && (kindType == 'targetSet' || kindType == 'optimize')" v-model="row.dec">
              <template #suffix>%</template>
            </el-input>
            <span v-else-if="$index == 0 || $index == 2">{{ row.dec }} <span style="color: #c0c4c0;">%</span></span>
            <span v-else>{{ row.dec }}</span>
          </template>
        </el-table-column>
      </el-table>
    </h-table-card>
    <br/>
    <h-button-group align="center">
      <h-button type="primary" @click="submit" v-if="kindType == 'targetSet' || kindType == 'optimize'" :loading="btnLoading">{{ h_i18n('939d5345ad4345dbaabe14798f6ac0f1') }}</h-button>
      <h-button type="default" @click="save" v-if="kindType == 'targetSet' || kindType == 'optimize'" :loading="btnLoading">{{ h_i18n('d8acae3bcfbc9ec9ade58c2dbacf65aa') }}</h-button>
    </h-button-group>
  </div>
</h-inspection-page>
</template>




<script setup>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

  import {reactive,getCurrentInstance,onMounted, onBeforeMount, nextTick, onUpdated, ref, defineEmit, computed ,watch, onActivated} from "vue";
  import { useRoute } from "vue-router";
  import loadJs  from "@/assets/js/loadJs.js"

  const { proxy, ctx } = getCurrentInstance();
  const route = useRoute();
  const M = ['jan','feb','mar','apr','may','jun','jul','aug','sept','oct','nov','dec']
  const optimizeMonth = new Date().getMonth() + 1
  const emit = defineEmit(
    ['submitSetting','saveBtn']
  )
  const props = defineProps({
    kindType: {
      type: String,
      default: ''
    },
    kindTypeName: {
      type: String,
      default: ''
    },
    getData: {
      type:Object,
      default: {}
    },
    btnLoading: {
      type: Boolean,
      default: false
    }
  })
  const inspectionUpdate = () => {
    proxy.postThisPageHeight()
  }
  const handleBack = () => {
    proxy.$router.back()
  }
  const data = reactive({
    tableLossTargetLabel:[],
    tableBadQuantityTargetLabel:[],
    isDec:false,
  })
  const initTableData = () => {
    data.tableLossTargetLabel = [
      {project:h_i18n('a754dabb451b1668009037edfa109947')},
      {project:h_i18n('0c78770ef512ea10e23f94be726e7c11')},
      {project:h_i18n('3f3e62729afacaa955a69eb8615465c5')},
      {project:h_i18n('ee2c1d22266d99192d3912036a146c85')},
      {project:h_i18n('e8fb4ee474957b4c13ac146e38bd3c82')},
    ]
    data.tableBadQuantityTargetLabel = [
      {project:h_i18n('a754dabb451b1668009037edfa109947')},
      {project:h_i18n('820abf165feb46635ef787b2ead0b725')},
      {project:h_i18n('3f3e62729afacaa955a69eb8615465c5')},
      {project:h_i18n('1bfc8e8c4777c05b86a15254af33c859')},
      {project:h_i18n('6598c547fe31e5f5891d4ea679218444')},
    ]
  }
  // 更新 
  const updateTableData = () => {
    // props.getData.getDataList 0 位是 损失 1 位是 数量
    data.tableLossTargetLabel[4] = {
      project:h_i18n('e8fb4ee474957b4c13ac146e38bd3c82'),...props.getData.getDataList[0]
    }
    data.tableBadQuantityTargetLabel[4] = {
      project:h_i18n('6598c547fe31e5f5891d4ea679218444'),...props.getData.getDataList[1]
    }
  }
  // 月份input数据变化 计算百分比
   const monthChange = (row,month,index) => {
    // console.log(row,month)
    let clearFlag = false
    row[month] =  Number(row[month]).toFixed(2) || ''
    
    if(index == 0){
      if(Number(data.tableLossTargetLabel[2][month]) < row[month]){
        proxy.$message({
          message: h_i18n('a6f3d576496f350177c89486f319d969'),
          type: 'warning',
        })
        // 先设置值为零，进行计算，再根据clearFlag清除
        row[month] = 0
        clearFlag = true
      }
      data.tableLossTargetLabel[1] = {
        project:h_i18n('0c78770ef512ea10e23f94be726e7c11'),
        // year : accMul(data.tableLossTargetLabel[4].year ,accDiv(data.tableLossTargetLabel[0].year, 100)) ,
        jan : accMul(data.tableLossTargetLabel[4].jan , accDiv(data.tableLossTargetLabel[0].jan , 100)),
        feb : accMul(data.tableLossTargetLabel[4].feb , accDiv(data.tableLossTargetLabel[0].feb , 100)),
        mar : accMul(data.tableLossTargetLabel[4].mar , accDiv(data.tableLossTargetLabel[0].mar , 100)),
        apr : accMul(data.tableLossTargetLabel[4].apr , accDiv(data.tableLossTargetLabel[0].apr , 100)),
        may : accMul(data.tableLossTargetLabel[4].may , accDiv(data.tableLossTargetLabel[0].may , 100)),
        jun : accMul(data.tableLossTargetLabel[4].jun , accDiv(data.tableLossTargetLabel[0].jun , 100)),
        jul : accMul(data.tableLossTargetLabel[4].jul , accDiv(data.tableLossTargetLabel[0].jul , 100)),
        aug : accMul(data.tableLossTargetLabel[4].aug , accDiv(data.tableLossTargetLabel[0].aug , 100)),
        sept : accMul(data.tableLossTargetLabel[4].sept , accDiv(data.tableLossTargetLabel[0].sept , 100)),
        oct : accMul(data.tableLossTargetLabel[4].oct , accDiv(data.tableLossTargetLabel[0].oct , 100)),
        nov : accMul(data.tableLossTargetLabel[4].nov , accDiv(data.tableLossTargetLabel[0].nov , 100)),
        dec : accMul(data.tableLossTargetLabel[4].dec , accDiv(data.tableLossTargetLabel[0].dec , 100)), 
      }
      // 根据clearFlag清除
    if(clearFlag){
      row[month] = undefined
      data.tableLossTargetLabel[1][month] = undefined
    }
    for(let i = 0; i < M.length; i++){
        data.tableLossTargetLabel[1].year = addFun(data.tableLossTargetLabel[1].year,data.tableLossTargetLabel[1][M[i]])
      }
    }
    if(index == 2){
      if(row[month] < Number(data.tableLossTargetLabel[0][month])){
        proxy.$message({
          message: h_i18n('a6f3d576496f350177c89486f319d969'),
          type: 'warning',
        })
        // 先设置值为零，进行计算，再根据clearFlag清除
        row[month] = 0
        clearFlag = true
      }
      data.tableLossTargetLabel[3] = {
        project:h_i18n('ee2c1d22266d99192d3912036a146c85'),
        // year : accMul(data.tableLossTargetLabel[4].year ,accDiv(data.tableLossTargetLabel[2].year, 100)) ,
        jan : accMul(data.tableLossTargetLabel[4].jan , accDiv(data.tableLossTargetLabel[2].jan , 100)),
        feb : accMul(data.tableLossTargetLabel[4].feb , accDiv(data.tableLossTargetLabel[2].feb , 100)),
        mar : accMul(data.tableLossTargetLabel[4].mar , accDiv(data.tableLossTargetLabel[2].mar , 100)),
        apr : accMul(data.tableLossTargetLabel[4].apr , accDiv(data.tableLossTargetLabel[2].apr , 100)),
        may : accMul(data.tableLossTargetLabel[4].may , accDiv(data.tableLossTargetLabel[2].may , 100)),
        jun : accMul(data.tableLossTargetLabel[4].jun , accDiv(data.tableLossTargetLabel[2].jun , 100)),
        jul : accMul(data.tableLossTargetLabel[4].jul , accDiv(data.tableLossTargetLabel[2].jul , 100)),
        aug : accMul(data.tableLossTargetLabel[4].aug , accDiv(data.tableLossTargetLabel[2].aug , 100)),
        sept : accMul(data.tableLossTargetLabel[4].sept , accDiv(data.tableLossTargetLabel[2].sept , 100)),
        oct : accMul(data.tableLossTargetLabel[4].oct , accDiv(data.tableLossTargetLabel[2].oct , 100)),
        nov : accMul(data.tableLossTargetLabel[4].nov , accDiv(data.tableLossTargetLabel[2].nov , 100)),
        dec : accMul(data.tableLossTargetLabel[4].dec , accDiv(data.tableLossTargetLabel[2].dec , 100)), 
      }
      // 根据clearFlag清除
    if(clearFlag){
      row[month] = undefined
      data.tableLossTargetLabel[3][month] = undefined
    }
    for(let i = 0; i < M.length; i++){
        data.tableLossTargetLabel[3].year = addFun(data.tableLossTargetLabel[3].year,data.tableLossTargetLabel[3][M[i]])
      }
    }
    row.year = ((Number(row.jan) || 0) + (Number(row.feb) || 0) + (Number(row.mar) || 0) +
    (Number(row.apr) || 0) + (Number(row.may) || 0) + (Number(row.jun) || 0) +
    (Number(row.jul) || 0) + (Number(row.aug) || 0) + (Number(row.sept) || 0) +
    (Number(row.oct) || 0) + (Number(row.nov) || 0) + (Number(row.dec) || 0) ).toFixed(2)
    
    // data.tableLossTargetLabel[1].year = ((data.tableLossTargetLabel[1].jan || 0) + (data.tableLossTargetLabel[1].feb || 0) + (data.tableLossTargetLabel[1].mar || 0) + 
    //   (data.tableLossTargetLabel[1].apr || 0) + (data.tableLossTargetLabel[1].may || 0) + (data.tableLossTargetLabel[1].jun || 0) + 
    //   (data.tableLossTargetLabel[1].jul || 0) + (data.tableLossTargetLabel[1].aug || 0) + (data.tableLossTargetLabel[1].sept || 0) + 
    //   (data.tableLossTargetLabel[1].oct || 0) + (data.tableLossTargetLabel[1].nov || 0) + (data.tableLossTargetLabel[1].dec || 0)).toFixed(4)
    // data.tableLossTargetLabel[3].year = ((data.tableLossTargetLabel[3].jan || 0) + (data.tableLossTargetLabel[3].feb || 0)+ (data.tableLossTargetLabel[3].mar || 0) + 
    // (data.tableLossTargetLabel[3].apr || 0) + (data.tableLossTargetLabel[3].may || 0) + (data.tableLossTargetLabel[3].jun || 0) + 
    // (data.tableLossTargetLabel[3].jul || 0) + (data.tableLossTargetLabel[3].aug || 0) + (data.tableLossTargetLabel[3].sept || 0) + 
    // (data.tableLossTargetLabel[3].oct || 0) + (data.tableLossTargetLabel[3].nov || 0) + (data.tableLossTargetLabel[3].dec || 0) ).toFixed(4)
   }
  // 月份变化 计算
  const changeMonth = (row,month,index) => {
    // console.log(row,month)
    let clearFlag = false
    row[month] =  Number(row[month]).toFixed(2) || ''
    
    if(index == 0){
      if(Number(data.tableBadQuantityTargetLabel[2][month]) < row[month]){
        proxy.$message({
          message: h_i18n('15dfe0fe66b3c3f0c13f458d883a963a'),
          type: 'warning',
        })
        // 先设置值为零，进行计算，再根据clearFlag清除
        row[month] = 0
        clearFlag = true
      }
      data.tableBadQuantityTargetLabel[1] = {
        project:h_i18n('820abf165feb46635ef787b2ead0b725'),
        // year : accMul(data.tableBadQuantityTargetLabel[4].year ,accDiv(data.tableBadQuantityTargetLabel[0].year, 100)) ,
        jan : accMul(data.tableBadQuantityTargetLabel[4].jan , accDiv(data.tableBadQuantityTargetLabel[0].jan , 100)),
        feb : accMul(data.tableBadQuantityTargetLabel[4].feb , accDiv(data.tableBadQuantityTargetLabel[0].feb , 100)),
        mar : accMul(data.tableBadQuantityTargetLabel[4].mar , accDiv(data.tableBadQuantityTargetLabel[0].mar , 100)),
        apr : accMul(data.tableBadQuantityTargetLabel[4].apr , accDiv(data.tableBadQuantityTargetLabel[0].apr , 100)),
        may : accMul(data.tableBadQuantityTargetLabel[4].may , accDiv(data.tableBadQuantityTargetLabel[0].may , 100)),
        jun : accMul(data.tableBadQuantityTargetLabel[4].jun , accDiv(data.tableBadQuantityTargetLabel[0].jun , 100)),
        jul : accMul(data.tableBadQuantityTargetLabel[4].jul , accDiv(data.tableBadQuantityTargetLabel[0].jul , 100)),
        aug : accMul(data.tableBadQuantityTargetLabel[4].aug , accDiv(data.tableBadQuantityTargetLabel[0].aug , 100)),
        sept : accMul(data.tableBadQuantityTargetLabel[4].sept , accDiv(data.tableBadQuantityTargetLabel[0].sept , 100)),
        oct : accMul(data.tableBadQuantityTargetLabel[4].oct , accDiv(data.tableBadQuantityTargetLabel[0].oct , 100)),
        nov : accMul(data.tableBadQuantityTargetLabel[4].nov , accDiv(data.tableBadQuantityTargetLabel[0].nov , 100)),
        dec : accMul(data.tableBadQuantityTargetLabel[4].dec , accDiv(data.tableBadQuantityTargetLabel[0].dec , 100)), 
      }
      // 根据clearFlag清除
      if(clearFlag){
        row[month] = undefined
        data.tableBadQuantityTargetLabel[1][month] = undefined
      }
      for(let i = 0; i < M.length; i++){
        data.tableBadQuantityTargetLabel[1].year = addFun(data.tableBadQuantityTargetLabel[1].year,data.tableBadQuantityTargetLabel[1][M[i]])
      }
    }
    if(index == 2){
      if(row[month] < Number(data.tableBadQuantityTargetLabel[0][month])){
        proxy.$message({
          message: h_i18n('15dfe0fe66b3c3f0c13f458d883a963a'),
          type: 'warning',
        })
        // 先设置值为零，进行计算，再根据clearFlag清除
        row[month] = 0
        clearFlag = true
      }
      data.tableBadQuantityTargetLabel[3] = {
        project:h_i18n('1bfc8e8c4777c05b86a15254af33c859'),
        // year : accMul(data.tableBadQuantityTargetLabel[4].year ,accDiv(data.tableBadQuantityTargetLabel[2].year, 100)) ,
        jan : accMul(data.tableBadQuantityTargetLabel[4].jan , accDiv(data.tableBadQuantityTargetLabel[2].jan , 100)),
        feb : accMul(data.tableBadQuantityTargetLabel[4].feb , accDiv(data.tableBadQuantityTargetLabel[2].feb , 100)),
        mar : accMul(data.tableBadQuantityTargetLabel[4].mar , accDiv(data.tableBadQuantityTargetLabel[2].mar , 100)),
        apr : accMul(data.tableBadQuantityTargetLabel[4].apr , accDiv(data.tableBadQuantityTargetLabel[2].apr , 100)),
        may : accMul(data.tableBadQuantityTargetLabel[4].may , accDiv(data.tableBadQuantityTargetLabel[2].may , 100)),
        jun : accMul(data.tableBadQuantityTargetLabel[4].jun , accDiv(data.tableBadQuantityTargetLabel[2].jun , 100)),
        jul : accMul(data.tableBadQuantityTargetLabel[4].jul , accDiv(data.tableBadQuantityTargetLabel[2].jul , 100)),
        aug : accMul(data.tableBadQuantityTargetLabel[4].aug , accDiv(data.tableBadQuantityTargetLabel[2].aug , 100)),
        sept : accMul(data.tableBadQuantityTargetLabel[4].sept , accDiv(data.tableBadQuantityTargetLabel[2].sept , 100)),
        oct : accMul(data.tableBadQuantityTargetLabel[4].oct , accDiv(data.tableBadQuantityTargetLabel[2].oct , 100)),
        nov : accMul(data.tableBadQuantityTargetLabel[4].nov , accDiv(data.tableBadQuantityTargetLabel[2].nov , 100)),
        dec : accMul(data.tableBadQuantityTargetLabel[4].dec , accDiv(data.tableBadQuantityTargetLabel[2].dec , 100)), 
      }
      // 根据clearFlag清除
      if(clearFlag){
        row[month] = undefined
        data.tableBadQuantityTargetLabel[3][month] = undefined
      }
      for(let i = 0; i < M.length; i++){
        data.tableBadQuantityTargetLabel[3].year = addFun(data.tableBadQuantityTargetLabel[3].year,data.tableBadQuantityTargetLabel[3][M[i]])
      }
    }
    row.year = ((Number(row.jan) || 0) + (Number(row.feb) || 0) + (Number(row.mar) || 0) +
    (Number(row.apr) || 0) + (Number(row.may) || 0) + (Number(row.jun) || 0) +
    (Number(row.jul) || 0) + (Number(row.aug) || 0) + (Number(row.sept) || 0) +
    (Number(row.oct) || 0) + (Number(row.nov) || 0) + (Number(row.dec) || 0) ).toFixed(2)
    // data.tableBadQuantityTargetLabel[1].year = ((data.tableBadQuantityTargetLabel[1].jan || 0) + (data.tableBadQuantityTargetLabel[1].feb || 0) + (data.tableBadQuantityTargetLabel[1].mar || 0) + 
    // (data.tableBadQuantityTargetLabel[1].apr || 0) + (data.tableBadQuantityTargetLabel[1].may || 0) + (data.tableBadQuantityTargetLabel[1].jun || 0) + 
    // (data.tableBadQuantityTargetLabel[1].jul || 0) + (data.tableBadQuantityTargetLabel[1].aug || 0) + (data.tableBadQuantityTargetLabel[1].sept || 0) + 
    // (data.tableBadQuantityTargetLabel[1].oct || 0) + (data.tableBadQuantityTargetLabel[1].nov || 0) + (data.tableBadQuantityTargetLabel[1].dec || 0))
    // data.tableBadQuantityTargetLabel[3].year = ((data.tableBadQuantityTargetLabel[3].jan || 0) + (data.tableBadQuantityTargetLabel[3].feb || 0)+ (data.tableBadQuantityTargetLabel[3].mar || 0) + 
    // (data.tableBadQuantityTargetLabel[3].apr || 0) + (data.tableBadQuantityTargetLabel[3].may || 0) + (data.tableBadQuantityTargetLabel[3].jun || 0) + 
    // (data.tableBadQuantityTargetLabel[3].jul || 0) + (data.tableBadQuantityTargetLabel[3].aug || 0) + (data.tableBadQuantityTargetLabel[3].sept || 0) + 
    // (data.tableBadQuantityTargetLabel[3].oct || 0) + (data.tableBadQuantityTargetLabel[3].nov || 0) + (data.tableBadQuantityTargetLabel[3].dec || 0) )
  }
  // 重新计算 
  const updateFunBad = () => {
    if(props.kindType != 'targetSet' && props.kindType != 'optimize'){
      return
    }
    console.log('updateFunBad')
    data.tableBadQuantityTargetLabel[0].project = h_i18n('a754dabb451b1668009037edfa109947')
    data.tableBadQuantityTargetLabel[2].project = h_i18n('3f3e62729afacaa955a69eb8615465c5')
    data.tableBadQuantityTargetLabel[4].project = h_i18n('6598c547fe31e5f5891d4ea679218444')
    data.tableBadQuantityTargetLabel[1] = {
      project:h_i18n('820abf165feb46635ef787b2ead0b725'),
      jan : accMul(data.tableBadQuantityTargetLabel[4].jan , accDiv(data.tableBadQuantityTargetLabel[0].jan , 100)),
      feb : accMul(data.tableBadQuantityTargetLabel[4].feb , accDiv(data.tableBadQuantityTargetLabel[0].feb , 100)),
      mar : accMul(data.tableBadQuantityTargetLabel[4].mar , accDiv(data.tableBadQuantityTargetLabel[0].mar , 100)),
      apr : accMul(data.tableBadQuantityTargetLabel[4].apr , accDiv(data.tableBadQuantityTargetLabel[0].apr , 100)),
      may : accMul(data.tableBadQuantityTargetLabel[4].may , accDiv(data.tableBadQuantityTargetLabel[0].may , 100)),
      jun : accMul(data.tableBadQuantityTargetLabel[4].jun , accDiv(data.tableBadQuantityTargetLabel[0].jun , 100)),
      jul : accMul(data.tableBadQuantityTargetLabel[4].jul , accDiv(data.tableBadQuantityTargetLabel[0].jul , 100)),
      aug : accMul(data.tableBadQuantityTargetLabel[4].aug , accDiv(data.tableBadQuantityTargetLabel[0].aug , 100)),
      sept : accMul(data.tableBadQuantityTargetLabel[4].sept , accDiv(data.tableBadQuantityTargetLabel[0].sept , 100)),
      oct : accMul(data.tableBadQuantityTargetLabel[4].oct , accDiv(data.tableBadQuantityTargetLabel[0].oct , 100)),
      nov : accMul(data.tableBadQuantityTargetLabel[4].nov , accDiv(data.tableBadQuantityTargetLabel[0].nov , 100)),
      dec : accMul(data.tableBadQuantityTargetLabel[4].dec , accDiv(data.tableBadQuantityTargetLabel[0].dec , 100)), 
    }
    data.tableBadQuantityTargetLabel[3] = {
      project:h_i18n('1bfc8e8c4777c05b86a15254af33c859'),
      jan : accMul(data.tableBadQuantityTargetLabel[4].jan , accDiv(data.tableBadQuantityTargetLabel[2].jan , 100)),
      feb : accMul(data.tableBadQuantityTargetLabel[4].feb , accDiv(data.tableBadQuantityTargetLabel[2].feb , 100)),
      mar : accMul(data.tableBadQuantityTargetLabel[4].mar , accDiv(data.tableBadQuantityTargetLabel[2].mar , 100)),
      apr : accMul(data.tableBadQuantityTargetLabel[4].apr , accDiv(data.tableBadQuantityTargetLabel[2].apr , 100)),
      may : accMul(data.tableBadQuantityTargetLabel[4].may , accDiv(data.tableBadQuantityTargetLabel[2].may , 100)),
      jun : accMul(data.tableBadQuantityTargetLabel[4].jun , accDiv(data.tableBadQuantityTargetLabel[2].jun , 100)),
      jul : accMul(data.tableBadQuantityTargetLabel[4].jul , accDiv(data.tableBadQuantityTargetLabel[2].jul , 100)),
      aug : accMul(data.tableBadQuantityTargetLabel[4].aug , accDiv(data.tableBadQuantityTargetLabel[2].aug , 100)),
      sept : accMul(data.tableBadQuantityTargetLabel[4].sept , accDiv(data.tableBadQuantityTargetLabel[2].sept , 100)),
      oct : accMul(data.tableBadQuantityTargetLabel[4].oct , accDiv(data.tableBadQuantityTargetLabel[2].oct , 100)),
      nov : accMul(data.tableBadQuantityTargetLabel[4].nov , accDiv(data.tableBadQuantityTargetLabel[2].nov , 100)),
      dec : accMul(data.tableBadQuantityTargetLabel[4].dec , accDiv(data.tableBadQuantityTargetLabel[2].dec , 100)), 
    }
    for(let i = 0; i < M.length; i++){
      data.tableBadQuantityTargetLabel[1].year = addFun(data.tableBadQuantityTargetLabel[1].year,data.tableBadQuantityTargetLabel[1][M[i]])
    }
    for(let i = 0; i < M.length; i++){
      data.tableBadQuantityTargetLabel[3].year = addFun(data.tableBadQuantityTargetLabel[3].year,data.tableBadQuantityTargetLabel[3][M[i]])
    }
    let row0 = data.tableBadQuantityTargetLabel[0]
    data.tableBadQuantityTargetLabel[0].year = ((Number(row0.jan) || 0) + (Number(row0.feb) || 0) + (Number(row0.mar) || 0) +
    (Number(row0.apr) || 0) + (Number(row0.may) || 0) + (Number(row0.jun) || 0) +
    (Number(row0.jul) || 0) + (Number(row0.aug) || 0) + (Number(row0.sept) || 0) +
    (Number(row0.oct) || 0) + (Number(row0.nov) || 0) + (Number(row0.dec) || 0) ).toFixed(2)
    let row2 = data.tableBadQuantityTargetLabel[2]
    data.tableBadQuantityTargetLabel[2].year = ((Number(row2.jan) || 0) + (Number(row2.feb) || 0) + (Number(row2.mar) || 0) +
    (Number(row2.apr) || 0) + (Number(row2.may) || 0) + (Number(row2.jun) || 0) +
    (Number(row2.jul) || 0) + (Number(row2.aug) || 0) + (Number(row2.sept) || 0) +
    (Number(row2.oct) || 0) + (Number(row2.nov) || 0) + (Number(row2.dec) || 0) ).toFixed(2)
  }
  // 重新计算 
  const updateFunLoss = () => {
    if(props.kindType != 'targetSet' && props.kindType != 'optimize'){
      return
    }
    console.log('updateFunLoss')
    data.tableLossTargetLabel[0].project = h_i18n('a754dabb451b1668009037edfa109947')
    data.tableLossTargetLabel[2].project = h_i18n('3f3e62729afacaa955a69eb8615465c5')
    data.tableLossTargetLabel[4].project = h_i18n('e8fb4ee474957b4c13ac146e38bd3c82')
    data.tableLossTargetLabel[1] = {
      project:h_i18n('0c78770ef512ea10e23f94be726e7c11'),
      jan : accMul(data.tableLossTargetLabel[4].jan , accDiv(data.tableLossTargetLabel[0].jan , 100)),
      feb : accMul(data.tableLossTargetLabel[4].feb , accDiv(data.tableLossTargetLabel[0].feb , 100)),
      mar : accMul(data.tableLossTargetLabel[4].mar , accDiv(data.tableLossTargetLabel[0].mar , 100)),
      apr : accMul(data.tableLossTargetLabel[4].apr , accDiv(data.tableLossTargetLabel[0].apr , 100)),
      may : accMul(data.tableLossTargetLabel[4].may , accDiv(data.tableLossTargetLabel[0].may , 100)),
      jun : accMul(data.tableLossTargetLabel[4].jun , accDiv(data.tableLossTargetLabel[0].jun , 100)),
      jul : accMul(data.tableLossTargetLabel[4].jul , accDiv(data.tableLossTargetLabel[0].jul , 100)),
      aug : accMul(data.tableLossTargetLabel[4].aug , accDiv(data.tableLossTargetLabel[0].aug , 100)),
      sept : accMul(data.tableLossTargetLabel[4].sept , accDiv(data.tableLossTargetLabel[0].sept , 100)),
      oct : accMul(data.tableLossTargetLabel[4].oct , accDiv(data.tableLossTargetLabel[0].oct , 100)),
      nov : accMul(data.tableLossTargetLabel[4].nov , accDiv(data.tableLossTargetLabel[0].nov , 100)),
      dec : accMul(data.tableLossTargetLabel[4].dec , accDiv(data.tableLossTargetLabel[0].dec , 100)), 
    }
    data.tableLossTargetLabel[3] = {
      project:h_i18n('ee2c1d22266d99192d3912036a146c85'),
      jan : accMul(data.tableLossTargetLabel[4].jan , accDiv(data.tableLossTargetLabel[2].jan , 100)),
      feb : accMul(data.tableLossTargetLabel[4].feb , accDiv(data.tableLossTargetLabel[2].feb , 100)),
      mar : accMul(data.tableLossTargetLabel[4].mar , accDiv(data.tableLossTargetLabel[2].mar , 100)),
      apr : accMul(data.tableLossTargetLabel[4].apr , accDiv(data.tableLossTargetLabel[2].apr , 100)),
      may : accMul(data.tableLossTargetLabel[4].may , accDiv(data.tableLossTargetLabel[2].may , 100)),
      jun : accMul(data.tableLossTargetLabel[4].jun , accDiv(data.tableLossTargetLabel[2].jun , 100)),
      jul : accMul(data.tableLossTargetLabel[4].jul , accDiv(data.tableLossTargetLabel[2].jul , 100)),
      aug : accMul(data.tableLossTargetLabel[4].aug , accDiv(data.tableLossTargetLabel[2].aug , 100)),
      sept : accMul(data.tableLossTargetLabel[4].sept , accDiv(data.tableLossTargetLabel[2].sept , 100)),
      oct : accMul(data.tableLossTargetLabel[4].oct , accDiv(data.tableLossTargetLabel[2].oct , 100)),
      nov : accMul(data.tableLossTargetLabel[4].nov , accDiv(data.tableLossTargetLabel[2].nov , 100)),
      dec : accMul(data.tableLossTargetLabel[4].dec , accDiv(data.tableLossTargetLabel[2].dec , 100)), 
    }
    for(let i = 0; i < M.length; i++){
      data.tableLossTargetLabel[1].year = addFun(data.tableLossTargetLabel[1].year,data.tableLossTargetLabel[1][M[i]])
    }
    for(let i = 0; i < M.length; i++){
      data.tableLossTargetLabel[3].year = addFun(data.tableLossTargetLabel[3].year,data.tableLossTargetLabel[3][M[i]])
    }
    let row0 = data.tableLossTargetLabel[0]
    data.tableLossTargetLabel[0].year = ((Number(row0.jan) || 0) + (Number(row0.feb) || 0) + (Number(row0.mar) || 0) +
    (Number(row0.apr) || 0) + (Number(row0.may) || 0) + (Number(row0.jun) || 0) +
    (Number(row0.jul) || 0) + (Number(row0.aug) || 0) + (Number(row0.sept) || 0) +
    (Number(row0.oct) || 0) + (Number(row0.nov) || 0) + (Number(row0.dec) || 0) ).toFixed(2)
    let row2 = data.tableLossTargetLabel[2]
    data.tableLossTargetLabel[2].year = ((Number(row2.jan) || 0) + (Number(row2.feb) || 0) + (Number(row2.mar) || 0) +
    (Number(row2.apr) || 0) + (Number(row2.may) || 0) + (Number(row2.jun) || 0) +
    (Number(row2.jul) || 0) + (Number(row2.aug) || 0) + (Number(row2.sept) || 0) +
    (Number(row2.oct) || 0) + (Number(row2.nov) || 0) + (Number(row2.dec) || 0) ).toFixed(2)
  }
  // 提交
  const submit = () => {
    let ym = ['year',...M]
    // 'jan','feb','mar','apr','may','jun','jul','aug','sept','oct','nov','dec'
    let name = [
      {year:h_i18n('a55a7858f27d0217db05f6de766d0154')},{jan:'1'},{year:h_i18n('a55a7858f27d0217db05f6de766d0154')},{year:h_i18n('a55a7858f27d0217db05f6de766d0154')},{year:h_i18n('a55a7858f27d0217db05f6de766d0154')},{year:h_i18n('a55a7858f27d0217db05f6de766d0154')},
    ]
    for(let i = 0; i < ym.length ; i ++){
      if(data.tableLossTargetLabel[0][ym[i]] === '' || data.tableLossTargetLabel[0][ym[i]] == undefined || data.tableLossTargetLabel[0][ym[i]] == null || data.tableLossTargetLabel[0][ym[i]] == NaN ){
        if(i>0){
          proxy.info(`${h_i18n('e3357544371acd9ae6607a61c15bfbad')}${i}${h_i18n('d015ea07e78f3fc8dd47923125891058')}`)
          return
        }else{
          proxy.info(`${h_i18n('c4ac56d43b7a3256823813e150a7a2e3')}`)
          return
        }
      }
      if(data.tableLossTargetLabel[2][ym[i]] === '' || data.tableLossTargetLabel[2][ym[i]] == undefined || data.tableLossTargetLabel[2][ym[i]] == null|| data.tableLossTargetLabel[2][ym[i]] == NaN ){
        if(i>0){
          proxy.info(`${h_i18n('285ac602a271d85486d6bf10f05caa1d')}${i}${h_i18n('d015ea07e78f3fc8dd47923125891058')}`)
          return
        }else{
          proxy.info(`${h_i18n('45228306b1bb14c58dd67f0f4011e916')}`)
          return
        }
      }
      if(data.tableBadQuantityTargetLabel[0][ym[i]] === '' || data.tableBadQuantityTargetLabel[0][ym[i]] == undefined || data.tableBadQuantityTargetLabel[0][ym[i]] == null || data.tableBadQuantityTargetLabel[0][ym[i]] == NaN ){
        if(i>0){
          proxy.info(`${h_i18n('0197977e8dc077cdf5b69034dd248416')}${i}${h_i18n('d015ea07e78f3fc8dd47923125891058')}`)
          return
        }else{
          proxy.info(`${h_i18n('f6393441791f6d7a666e00ee69ee4e4e')}`)
          return
        }
      }
      if(data.tableBadQuantityTargetLabel[2][ym[i]] === '' || data.tableBadQuantityTargetLabel[2][ym[i]] == undefined || data.tableBadQuantityTargetLabel[2][ym[i]] == null || data.tableBadQuantityTargetLabel[2][ym[i]] == NaN ){
        if(i>0){
          proxy.info(`${h_i18n('79d40361a0b01fc125f4fe7cd3541f71')}${i}${h_i18n('d015ea07e78f3fc8dd47923125891058')}`)
          return
        }else{
          proxy.info(`${h_i18n('409483b06033e818116408f81d6fee4e')}`)
          return
        }
      }
    }
    emit('submitSetting',{loss:data.tableLossTargetLabel ,bad: data.tableBadQuantityTargetLabel})
  }
// 暂存
const save = () => {
  emit('saveBtn',{loss:data.tableLossTargetLabel ,bad: data.tableBadQuantityTargetLabel})
}
// 加法函数
const addFun = (arg1, arg2) => {
  if(data.isDec){
    if(!arg1){
      arg1 = 0
    }
    if(!arg2){
      arg2 = 0
    }
      return Decimal(arg1).add(Decimal(arg2)).toNumber()
    
  }else{
    console.log('没有载入3')
    let r1, r2, m, n;
    try {
      r1 = arg1.toString().split('.')[1].length;
    } catch (e) {
      r1 = 0;
    }
    try {
      r2 = arg2.toString().split('.')[1].length;
    } catch (e) {
      r2 = 0;
    }
    m = Math.pow(10, Math.max(r1, r2));
    n = (r1 >= r2) ? r1 : r2;
    return ((arg1 * m + arg2 * m) / m).toFixed(n);
  }
}

/**
 ** 乘法函数，用来得到精确的乘法结果
 ** 说明：javascript的乘法结果会有误差，在两个浮点数相乘的时候会比较明显。这个函数返回较为精确的乘法结果。
 ** 调用：accMul(arg1,arg2)
 ** 返回值：arg1乘以 arg2的精确结果
 **/
const accMul = (arg1, arg2) => {
  if(data.isDec){
    if(arg1 && arg2){
      return Decimal(arg1).mul(Decimal(arg2)).toNumber()
    }else if(arg2 === 0.00){
      return 0
    }
  }else{
    console.log('没有载入')
    let m = 0
    let	s1 = arg1.toString()
    let	s2 = arg2.toString()
    try {
      m += s1.split(".")[1].length;
    } catch (e) {}
    try {
      m += s2.split(".")[1].length;
    } catch (e) {}
    return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
  }
}

/** 
 ** 除法函数，用来得到精确的除法结果
 ** 说明：javascript的除法结果会有误差，在两个浮点数相除的时候会比较明显。这个函数返回较为精确的除法结果。
 ** 调用：accDiv(arg1,arg2)
 ** 返回值：arg1除以arg2的精确结果
 **/
 const accDiv = (arg1, arg2) => {
  if(data.isDec){
    if(arg1 && arg2){
      return Decimal(arg1).div(Decimal(arg2)).toNumber()
    }else if(arg1 === 0.00){
      return 0
    }
  }else{
    console.log('没有载入2')
    let t1 = 0
    let	t2 = 0
    let	r1 = null
    let r2 = null
    try {
      t1 = arg1.toString().split('.')[1].length;
    } catch (e) {}
    try {
      t2 = arg2.toString().split('.')[1].length;
    } catch (e) {}
      r1 = Number(arg1.toString().replace('.', ''));
      r2 = Number(arg2.toString().replace('.', ''));
      return (r1 / r2) * Math.pow(10, t2 - t1);
  }
 }
 watch(props.getData.getDataList,(value,oldValue)=>{
  if(value){
    updateTableData()
  }
})
watch(() => props.getData.tableBadQuantityTargetLabel,(value,oldValue)=>{
  if(value){
    data.tableBadQuantityTargetLabel = props.getData.tableBadQuantityTargetLabel
    let intbad = setInterval(() => {
      if(data.isDec){
        updateFunBad()
        clearInterval(intbad)
      }
    }, 50);
  }
})
watch(() => props.getData.tableLossTargetLabel,(value,oldValue)=>{
  if(value){
    data.tableLossTargetLabel = props.getData.tableLossTargetLabel
    let intloss = setInterval(() => {
      if(data.isDec){
        updateFunLoss()
        clearInterval(intloss)
      }
    }, 50);
  }
})
onBeforeMount(()=>{
   // 引入decimal.js
   loadJs('https://cdn.bootcdn.net/ajax/libs/decimal.js/10.4.3/decimal.js').then(()=>{
      console.log('Decimal加载成功')
      data.isDec = true
    })
})
  onMounted(()=>{
    // 引入decimal.js
    // loadJs('@/assets/js/decimal.js').then(()=>{
    //   console.log('Decimal加载成功')
    //   data.isDec = true
    // })
    initTableData()
  })

</script>

<style lang="scss">
.hwork_targetSigned_inner_table_style{
  padding: 4px 16px 16px;
  background: #fff;
  margin-top: 12px;
  border-radius: 8px;
  .el-table::before {
    background-color: transparent;
  }
  table{
    tbody{
      tr:last-child{
        td:first-child{
          border-bottom-left-radius: 8px;
        }
        td:last-child{
          border-bottom-right-radius: 8px;
        }
      }
      td{
        height: 44px;
        .el-input{
          .el-input__inner{
            height: 24px;
          }
        }
      }
    }
  }
  .targetSigned_table_title_style{
    padding-top: 12px;
    padding-bottom: 4px;
    line-height: 22px;
    .targetSigned_table_left_style{
      color:#1D2129;
      font-weight: 500;
      padding-right: 8px;
      font-size: 14px;
    }
    .targetSigned_table_right_style{
      border-left: 1px solid #ccc;
      font-weight: 400;
      color:#86909C;
      padding-left: 8px;
    }
  }
}
</style>